export const WIN_MESSAGES = ['Great Job!', 'Awesome!', 'Well done!']
export const GAME_COPIED_MESSAGE = 'Game copied to clipboard'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Not enough letters'
export const WORD_NOT_FOUND_MESSAGE = 'Word not found'
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const NEXT_GAME_TEXT = 'Next game starts in'
export const SHARE_TEXT = 'Share'
